import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { StagLogo } from "./StagLogo";

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center" data-testid="auth-loading">
        <div className="text-purple-400 animate-pulse">
          <StagLogo size={64} />
        </div>
      </div>
    );
  }

  if (user === false) {
    // Send guests to sign-in and bring them back here afterwards (SignInPage honours ?next=).
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={`/sign-in?next=${encodeURIComponent(next)}`} replace />;
  }

  return children;
}
